import React, { useEffect, useState, useRef} from "react";
import CryptoJS from "crypto-js";
import AllSvg from "../../assets/images/all.svg";
import filterSvg from "../../assets/images/filter.svg";
import { SlTooltip } from "@shoelace-style/shoelace/dist/react";
import sundayIcon from "../../assets/images/sunday.svg";
import closeSvg from "../../assets/images/uncheck.svg";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { SetComponentId, SetSelectedYear } from "../../redux/counterSlice";
import { ScrollContainer } from "react-indiana-drag-scroll";
import YearCalendar from "../../shared/YearlyCalendar";
import api from "../../services/api";
import { useSelector } from "react-redux";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import {
  SlIcon,
  SlTabGroup,
  SlTab,
  SlDrawer,
} from "@shoelace-style/shoelace/dist/react";
import { useNavigate } from "react-router-dom";
import { alphabets, BrandsTypes, languageOptions, roles } from "../../utils/constants";
import B2BPreview from "./B2BPreview";
import config from "../../config";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Toast } from "../../shared/Toast";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

function MarketSpendTracker() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  dispatch(SetComponentId(35));
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const allowedNewUserTypes = [...new Set(salesUsersList.map(item => item.new_user_type))]
  const [tempSalesUsersList, setTempSalesUsersList] = useState(salesUsersList)
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const currentdate = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
  const OpsSales = useSelector((state) => state.Head.opssales);
  const searchWord = useSelector((state) => state.Head.adssearch);
  const [selectedReport, setSelectedReport] = useState("All");
  const [marketSpend, setMarketSpend] = useState([]);
  const [loader, setLoader] = useState(false);
  const [language, setLanguage] = useState("0");
  const [newspaperData, setNewsPaperData] = useState([]);
  const [B2BShow, setB2BShow] = useState(false);
  const [brand, setBrand] = useState();
  const [date, setDate] = useState();
  const [all, setAll] = useState(false);
  const [activeStatus, setActiveStatus] = useState(true);

  const [compareYear, setCompareYear] = useState(null); 
  const [compareMarketSpend, setCompareMarketSpend] = useState([]);
  const [mergedData,setmergedData] = useState(null);
  const [showdata, setshowdata] = useState(true);
  const [showcomparecalendar,setshowcomparecalendar] = useState(true);

  const [columnWidths, setColumnWidths] = useState({});
  const [sortOn, setSortOn] = useState({
    sortByType: "newspaper",
    sortByColumn: "amount",
    sortOrder: "desc",
    dataNeedToSorted: ""
  });

  
  const [selectedList, setSelectedList] = useState(
    localStorage.getItem("selectedSalesList") && salesUsersList?.length > 1 &&
      JSON.parse(localStorage.getItem("selectedSalesList")).length
      ? salesUsersList.filter((item) =>
          JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
            item.value
          )
        )
      : salesUsersList?.length > 1 ? [] : []
  );
  const [salesPerson_id, setSalesPerson_id] = useState(
      salesUsersList?.length > 1 ? localStorage.getItem("selectedSalesList") &&
        JSON.parse(localStorage.getItem("selectedSalesList")).length
        ? salesUsersList.filter((item) =>
            JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
              item.value
            )
          )[0]?.value || -1
        : salesUsersList[0]?.value
      : -1
  );
  const [initialRender, setIntialRender] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [fetchW2n, setFetchW2n] = useState(false);
  const [fetchW2nCampaign_type, setFetchW2nCampaign_type] = useState(null);

  const [filterActiveLetters, setFilterActiveLetters] = useState([...new Set(
      salesUsersList.map((item) =>{
        return item?.label[0]?.toUpperCase()
      }
      ).sort()
    )]);
    const [searchFilter, setSearchFilter] = useState('')
const [showUsersFilter, setShowUsersFilter] = useState( false
    // JSON.parse(localStorage.getItem("selectedSalesList"))?.length ? false : salesUsersList?.length > 1 ?  true : false
  )
  const [newUserTypeInfilter, setNewUserTypeInfilter] = useState(0)
  
  const mergedTwoYearsData = (firstyear,secondyear) =>{

    const allBrands = Array.from(
      new Set([...firstyear.map(b => b.brand_id), ...secondyear.map(b => b.brand_id)])
    )
      .map(brand_id => {
        return {
          brand_id,
          selected: firstyear.find(b => b.brand_id === brand_id) || null,
          compare: secondyear.find(b => b.brand_id === brand_id) || null
        };
      })
      .sort((a, b) => {
        const aBoth = a.selected && a.compare ? 0 : 1;
        const bBoth = b.selected && b.compare ? 0 : 1;
        return aBoth - bBoth;
      });
    
    setmergedData(allBrands);
    setshowdata(true);
    return allBrands;
  }
  const formatAmount = (amount) => {
    let unit = "";
    if (amount >= 10000000) {
      // 1 crore = 10,000,000
      amount = (amount / 10000000).toFixed(3);
      unit = "Cr";
    } else {
      amount = (amount / 100000).toFixed(2); // 1 lakh = 100,000
      unit = "L";
    }

    return `${amount + "" + unit}`;
  };

  const calculateCount = (data, type, campaign_type) => {
    let camp_counts = 0;
    let amount = 0;
    let dates_count = 0;
    if(campaign_type){
      data = data.filter(item => item.campaign_type === campaign_type)
    }
    data.map((record) => {
      camp_counts += record.count;
      amount += record.amount;
      dates_count += record.dates_count;
    });
    // if (type === "camps") return camp_counts;

    // if(from === "download"){
    //   return amount
    // }
    switch (type) {
      case "count":
        return camp_counts;
      case "amount":
        return amount;
      case "dates_count":
        return dates_count;
    }
  };

  const fetchNewsPapers = async () => {
    try {
      let res = await api({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNewsPaperData([...res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const filteredNewspapers = newspaperData.filter((np) => {
    // Include "Way2news" for Telugu, Tamil, and All languages
    // if (np.name.toLowerCase() === "way2news") {
    //   return false;
    // }
    return `${np.language}` === language || language === "0";
  });
  function  getTrackerSpend(data, year, month, campaign_type) {
    year = new Date(year).getFullYear();
    const targetDate = new Date(year, month - 1, 1).getTime() / 1000; // Convert to seconds since epoch
    if(!data)
    {
        return {
          amount: "",
          count: "",
          dates_count: "",
          amountinr: "",
        };
    }
    for (let entry of data) {
      if (
        entry.month === targetDate &&
        (campaign_type ? campaign_type === entry.campaign_type : true)
      ) {
        const amount = entry.amount;
        let formattedAmount, unit;

        if (amount >= 10000000) {
          // 1 crore = 10,000,000
          formattedAmount = (amount / 10000000).toFixed(3);
          unit = "cr";
        } else {
          formattedAmount = (amount / 100000).toFixed(2); // 1 lakh = 100,000
          unit = "L";
        }
        return {
          amount: formattedAmount + "" + unit,
          count: entry.count,
          dates_count: entry.dates_count,
          amountinr: entry.amount,
        };
      }
    }

    return {
      amount: "0",
      count: 0,
      dates_count: 0,
      amountinr: 0,
    };
  }

  const fetchMarketSpend = async (type = "primary") => {
    
    const yearTimestamp =
    type === "primary"
      ? selectedYear // already a timestamp
      : Math.floor(new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime());
    // console.log("year",yearTimestamp,type);
    // if(compareYear)
    // {
    //   if(selectedYear === Math.floor(new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime()))
    //   {
    //     Toast("info","Both Years should Not Be Same")
    //     setshowdata(false);
    //     return;
    //   }
    // }
    setLoader(true);
    try {
      let res = await api({
        url: "/market/get_tracker_spend",
        method: "POST",
        responseType: "json",
        data: {
          date:
            Math.round(yearTimestamp / 1000) < 10 || initialRender
              ? Math.round(currentdate / 1000)
              : Math.round(yearTimestamp / 1000),
          newspaper_name: selectedReport,
          lang_id: parseInt(language),
          sales_id: salesPerson_id !== -1 ? salesPerson_id : undefined,
          search: searchWord,
          active: activeStatus,
        },
      });
      if (res.code === 200) {
        if(type === "primary")
        {
          setMarketSpend(res.data); 
        }
        else
        {  
          setCompareMarketSpend(res.data);
        }
        setIntialRender(false);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    } finally {
      setLoader(false);
    }
  };
  const handleLanguage = (e) => {
    setLanguage(e.target.value);
    setSelectedReport("All");
  };
  const getTotalCounts = () => {
    let total_count = 0;
    let total_spent = 0;
    marketSpend?.map((record) => {
      record.data.map((data) => {
        total_count += data.count;
        total_spent += data.amount;
      });
    });
    return { count: total_count, amount: formatAmount(total_spent) };
  };
  const CountAmount = getTotalCounts();
  useEffect(() => {
    if (!initialRender) fetchMarketSpend("primary");
  }, [
    selectedReport,
    selectedYear,
    language,
    searchWord,
    salesPerson_id,
    activeStatus,
  ]);
  useEffect(() => {
    if (compareYear) {
      fetchMarketSpend("compare"); // fetch compare year data
    }
  }, [
    compareYear,
    selectedReport,
    language,
    searchWord,
    salesPerson_id,
    activeStatus,
  ]);
  
  useEffect(()=>{
    if(compareYear)
    { 
      // console.log("selected year changed");
      mergedTwoYearsData(marketSpend,compareMarketSpend);
    }
  },[marketSpend])
  useEffect(()=>{
    if(compareYear)
      mergedTwoYearsData(marketSpend,compareMarketSpend);
  },[compareMarketSpend])

  useEffect(() => {
    fetchNewsPapers();
    fetchMarketSpend();
  }, []);
  
  
  const comparedownload = async () =>{
    console.log("compareDownload____________________");
    let selectedata ="";
    let comparedata ="";
    try{
      let res = await api({
        url: "/market/get_tracker_spend",
        method: "POST",
        responseType: "json",
        data: {
          date: Math.round(selectedYear / 1000),
          newspaper_name: selectedReport,
          lang_id: parseInt(language),
          sales_id:
            selectedList.length > 0
              ? selectedList.map((item) => item.value)
              : undefined,
          search: searchWord,
          active: activeStatus,
        },
      });
      if(res.code == 200)
      {
         selectedata = res.data;
      }
      let res2 = await api({
        url: "/market/get_tracker_spend",
        method: "POST",
        responseType: "json",
        data: {
          date: Math.round(Math.floor(new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime())/1000),
          newspaper_name: selectedReport,
          lang_id: parseInt(language),
          sales_id:
            selectedList.length > 0
              ? selectedList.map((item) => item.value)
              : undefined,
          search: searchWord,
          active: activeStatus,
        },
      });
      if(res2.code == 200)
      {
        comparedata = res2.data;
      }
      if(comparedata || selectedata)
      { 
        // console.log("this is both years data",selectedata,comparedata)
        const totaldata = mergedTwoYearsData(selectedata,comparedata)
        // console.log("totalData",totaldata);
        const workbook = XLSX.utils.book_new();
        let sales_people = selectedList || [];
        // console.log("-list",selectedList);
        if (sales_people.length === 0) {
          sales_people.push({
            label: localStorage.getItem("name"),
            value: selectedata[0].sales_person_id || 95,
          });
        };
      // console.log("salespeople",sales_people);
      // --- Individual sheets ---
      sales_people.forEach((salesPerson) => {
        const sheetData = [];
        const salespersonMarketData = totaldata.filter((item) => 
          (item.selected && item.selected?.sales_person_id === salesPerson.value) ||
          (item.compare && item.compare?.sales_person_id === salesPerson.value)
        );
        
        // console.log("--------------------",salespersonMarketData);
        // --- Header row ---
        sheetData.push([
          "Client Name",
          ...Array.from({ length: 12 }, (_, i) => [
            `${months[i]} ${compareYear} Camps`,
            `${months[i]} ${compareYear} Insertions`,
            `${months[i]} ${compareYear} Amount`,
            `${months[i]} ${compareYear} W2N CPD Camps`,
            `${months[i]} ${compareYear} W2N CPD Inserts`,
            `${months[i]} ${compareYear} W2N CPD Amount`,
            `${months[i]} ${compareYear} W2N CPM Camps`,
            `${months[i]} ${compareYear} W2N CPM Inserts`,
            `${months[i]} ${compareYear} W2N CPM Amount`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} Camps`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} Insertions`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} Amount`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} W2N CPD Camps`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} W2N CPD Inserts`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} W2N CPD Amount`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} W2N CPM Camps`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} W2N CPM Inserts`,
            `${months[i]} ${new Date(selectedYear).getFullYear()} W2N CPM Amount`,
          ]).flat(),
          // Right-most totals
          `Total Camps ${compareYear}`,
          `Total Insertions ${compareYear}`,
          `Total Spent ${compareYear}`,
          `Total CPD W2N Camps ${compareYear}`,
          `Total CPD W2N Inserts ${compareYear}`,
          `Total CPD W2N Spent ${compareYear}`,
          `Total CPM W2N Camps ${compareYear}`,
          `Total CPM W2N Inserts ${compareYear}`,
          `Total CPM W2N Spent ${compareYear}`,
          `Total Camps ${new Date(selectedYear).getFullYear()}`,
          `Total Insertions ${new Date(selectedYear).getFullYear()}`,
          `Total Spent ${new Date(selectedYear).getFullYear()}`,
          `Total CPD W2N Camps ${new Date(selectedYear).getFullYear()}`,
          `Total CPD W2N Inserts ${new Date(selectedYear).getFullYear()}`,
          `Total CPD W2N Spent ${new Date(selectedYear).getFullYear()}`,
          `Total CPM W2N Camps ${new Date(selectedYear).getFullYear()}`,
          `Total CPM W2N Inserts ${new Date(selectedYear).getFullYear()}`,
          `Total CPM W2N Spent ${new Date(selectedYear).getFullYear()}`,
        ]);

      salespersonMarketData.forEach((item) => {
        const row = [
          item.compare?.brand_name || item.selected?.brand_name,
          ...Array.from({ length: 12 }, (_, i) => {
            const month = i + 1;

            const compareData = getTrackerSpend(item.compare?.data, new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(), month, "");
            const compareCPD = getTrackerSpend(item.compare?.w2ndata, new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(), month, "CPD");
            const compareCPM = getTrackerSpend(item.compare?.w2ndata, new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(), month, "CPM");
            
            const selectedData = getTrackerSpend(item.selected?.data, selectedYear, month, "");
            const selectedCPD = getTrackerSpend(item.selected?.w2ndata, selectedYear, month, "CPD");
            const selectedCPM = getTrackerSpend(item.selected?.w2ndata, selectedYear, month, "CPM");
            
            // Check if all metrics are zero for “no data”
            const isCompareEmpty = compareData.count === 0 && compareData.dates_count === 0 &&
                                   compareCPD.count === 0 && compareCPD.dates_count === 0 &&
                                   compareCPM.count === 0 && compareCPM.dates_count === 0;
            
            const isSelectedEmpty = selectedData.count === 0 && selectedData.dates_count === 0 &&
                                    selectedCPD.count === 0 && selectedCPD.dates_count === 0 &&
                                    selectedCPM.count === 0 && selectedCPM.dates_count === 0;
            
            // Replace zeros with empty string if no data
            return [
              isCompareEmpty ? "" : compareData.dates_count,
              isCompareEmpty ? "" : compareData.count,
              isCompareEmpty ? "" : compareData.amountinr,
              isCompareEmpty ? "" : compareCPD.dates_count,
              isCompareEmpty ? "" : compareCPD.count,
              isCompareEmpty ? "" : compareCPD.amountinr,
              isCompareEmpty ? "" : compareCPM.dates_count,
              isCompareEmpty ? "" : compareCPM.count,
              isCompareEmpty ? "" : compareCPM.amountinr,
              isSelectedEmpty ? "" : selectedData.dates_count,
              isSelectedEmpty ? "" : selectedData.count,
              isSelectedEmpty ? "" : selectedData.amountinr,
              isSelectedEmpty ? "" : selectedCPD.dates_count,
              isSelectedEmpty ? "" : selectedCPD.count,
              isSelectedEmpty ? "" : selectedCPD.amountinr,
              isSelectedEmpty ? "" : selectedCPM.dates_count,
              isSelectedEmpty ? "" : selectedCPM.count,
              isSelectedEmpty ? "" : selectedCPM.amountinr,
            ];
          }).flat(),
          // Totals per year
          calculateCount(item.compare?.data || [], "dates_count", null),
          calculateCount(item.compare?.data || [], "count", null ),
          calculateCount(item.compare?.data || [], "amount", null ),
          calculateCount(item.compare?.w2ndata || [], "dates_count", "CPD"),
          calculateCount(item.compare?.w2ndata || [], "count", "CPD"),
          calculateCount(item.compare?.w2ndata || [], "amount", "CPD"),
          calculateCount(item.compare?.w2ndata || [], "dates_count", "CPM"),
          calculateCount(item.compare?.w2ndata || [], "count", "CPM"),
          calculateCount(item.compare?.w2ndata || [], "amount", "CPM"),
          calculateCount(item.selected?.data || [], "dates_count", null),
          calculateCount(item.selected?.data || [], "count", null),
          calculateCount(item.selected?.data || [], "amount", null),
          calculateCount(item.selected?.w2ndata || [], "dates_count", "CPD"),
          calculateCount(item.selected?.w2ndata || [], "count", "CPD"),
          calculateCount(item.selected?.w2ndata || [], "amount", "CPD"),
          calculateCount(item.selected?.w2ndata || [], "dates_count", "CPM"),
          calculateCount(item.selected?.w2ndata || [], "count", "CPM"),
          calculateCount(item.selected?.w2ndata ||[], "amount", "CPM"),
        ];

        sheetData.push(row);
      });
      const totalRow = ["TOTAL"];
      for (let col = 1; col < sheetData[0].length; col++) {
        const sum = sheetData
          .slice(1) // ignore header row
          .reduce((acc, row) => acc + (Number(row[col]) || 0), 0);
        totalRow.push(sum);
      }
      sheetData.push(totalRow);

    // --- Then append individual salesperson sheet ---
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    let match = salesPerson.label.match(/^(.+?)\(\s*(.+?)\s*\)$/);
    let SaleTitleName = match ? match[1] : salesPerson.label;
    let sheetName = `${SaleTitleName?.slice(0, 25) || SaleTitleName}_${salesPerson.value}`;
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      });
     
      // --- COMBINED SHEET ---
      const combinedSheetData = [];
      const selectedYearVal = new Date(selectedYear).getFullYear(); // convert once

      // Header row
      combinedSheetData.push([
        "Sales Person Name",
        "Client Name",
        ...Array.from({ length: 12 }, (_, i) => [
          `${months[i]} ${compareYear} Camps`,
          `${months[i]} ${compareYear} Insertions`,
          `${months[i]} ${compareYear} Amount`,
          `${months[i]} ${compareYear} W2N CPD Camps`,
          `${months[i]} ${compareYear} W2N CPD Inserts`,
          `${months[i]} ${compareYear} W2N CPD Amount`,
          `${months[i]} ${compareYear} W2N CPM Camps`,
          `${months[i]} ${compareYear} W2N CPM Inserts`,
          `${months[i]} ${compareYear} W2N CPM Amount`,
          `${months[i]} ${selectedYearVal} Camps`,
          `${months[i]} ${selectedYearVal} Insertions`,
          `${months[i]} ${selectedYearVal} Amount`,
          `${months[i]} ${selectedYearVal} W2N CPD Camps`,
          `${months[i]} ${selectedYearVal} W2N CPD Inserts`,
          `${months[i]} ${selectedYearVal} W2N CPD Amount`,
          `${months[i]} ${selectedYearVal} W2N CPM Camps`,
          `${months[i]} ${selectedYearVal} W2N CPM Inserts`,
          `${months[i]} ${selectedYearVal} W2N CPM Amount`,
        ]).flat(),
        // Totals columns
        `Total Camps ${compareYear}`, `Total Insertions ${compareYear}`, `Total Spent ${compareYear}`,
        `Total CPD W2N Camps ${compareYear}`, `Total CPD W2N Inserts ${compareYear}`, `Total CPD W2N Spent ${compareYear}`,
        `Total CPM W2N Camps ${compareYear}`, `Total CPM W2N Inserts ${compareYear}`, `Total CPM W2N Spent ${compareYear}`,
        `Total Camps ${selectedYearVal}`, `Total Insertions ${selectedYearVal}`, `Total Spent ${selectedYearVal}`,
        `Total CPD W2N Camps ${selectedYearVal}`, `Total CPD W2N Inserts ${selectedYearVal}`, `Total CPD W2N Spent ${selectedYearVal}`,
        `Total CPM W2N Camps ${selectedYearVal}`, `Total CPM W2N Inserts ${selectedYearVal}`, `Total CPM W2N Spent ${selectedYearVal}`,
      ]);

      // Loop over all salespeople
      sales_people.forEach((salesPerson) => {
        const salespersonMarketData = totaldata.filter((item) =>
          (item.selected && item.selected?.sales_person_id === salesPerson.value) ||
          (item.compare && item.compare?.sales_person_id === salesPerson.value)
        );

        if (salespersonMarketData.length === 0) {
          const emptyRow = [
            salesPerson.label,
            "No Data",
            ...Array(combinedSheetData[0].length - 2).fill(0)
          ];
          combinedSheetData.push(emptyRow);
        } else {
          salespersonMarketData.forEach((item) => {
            const row = [
              salesPerson.label,
              item.compare?.brand_name || item.selected?.brand_name,
              ...Array.from({ length: 12 }, (_, i) => {
                const month = i + 1;

                const compareData = getTrackerSpend(item.compare?.data, new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(), month,"");
                const compareCPD = getTrackerSpend(item.compare?.w2ndata, new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(), month, "CPD");
                const compareCPM = getTrackerSpend(item.compare?.w2ndata, new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(), month, "CPM");

                const selectedData = getTrackerSpend(item.selected?.data, selectedYear, month,"");
                const selectedCPD = getTrackerSpend(item.selected?.w2ndata, selectedYear, month, "CPD");
                const selectedCPM = getTrackerSpend(item.selected?.w2ndata, selectedYear, month, "CPM");

                return [
                  compareData.dates_count,
                  compareData.count,
                  compareData.amountinr,
                  compareCPD.dates_count,
                  compareCPD.count,
                  compareCPD.amountinr,
                  compareCPM.dates_count,
                  compareCPM.count,
                  compareCPM.amountinr,
                  selectedData.dates_count,
                  selectedData.count,
                  selectedData.amountinr,
                  selectedCPD.dates_count,
                  selectedCPD.count,
                  selectedCPD.amountinr,
                  selectedCPM.dates_count,
                  selectedCPM.count,
                  selectedCPM.amountinr,
                ];
              }).flat(),
              // Totals per year
              calculateCount(item.compare?.data || [], "dates_count", null),
              calculateCount(item.compare?.data || [], "count", null ),
              calculateCount(item.compare?.data || [], "amount", null ),
              calculateCount(item.compare?.w2ndata || [], "dates_count", "CPD"),
              calculateCount(item.compare?.w2ndata || [], "count", "CPD"),
              calculateCount(item.compare?.w2ndata || [], "amount", "CPD"),
              calculateCount(item.compare?.w2ndata || [], "dates_count", "CPM"),
              calculateCount(item.compare?.w2ndata || [], "count", "CPM"),
              calculateCount(item.compare?.w2ndata || [], "amount", "CPM"),
              calculateCount(item.selected?.data || [], "dates_count", null),
              calculateCount(item.selected?.data || [], "count", null),
              calculateCount(item.selected?.data || [], "amount", null),
              calculateCount(item.selected?.w2ndata || [], "dates_count", "CPD"),
              calculateCount(item.selected?.w2ndata || [], "count", "CPD"),
              calculateCount(item.selected?.w2ndata || [], "amount", "CPD"),
              calculateCount(item.selected?.w2ndata ||[], "dates_count", "CPM"),
              calculateCount(item.selected?.w2ndata || [], "count", "CPM"),
              calculateCount(item.selected?.w2ndata || [], "amount", "CPM"),
            ];

            combinedSheetData.push(row);
          });
        }
      });
      
      const totalRow = ["TOTAL", ""];
      for (let col = 2; col < combinedSheetData[0].length; col++) {
        const sum = combinedSheetData
          .slice(1)
          .reduce((acc, row) => acc + (Number(row[col]) || 0), 0);
        totalRow.push(sum);
      }
      combinedSheetData.push(totalRow);
      
      const combinedWorksheet = XLSX.utils.aoa_to_sheet(combinedSheetData);
      XLSX.utils.book_append_sheet(workbook, combinedWorksheet, "All Salespersons Comparison");

      // --- Finally save workbook ---
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
      const excelBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(excelBlob, "salespersons_data_comparison.xlsx");
      }
    }catch(error)
    {
      console.log(error);
    }
  }
  const downLoadData = async () => {

    try {
      let res = await api({
        url: "/market/get_tracker_spend",
        method: "POST",
        responseType: "json",
        data: {
          date: Math.round(selectedYear / 1000),
          newspaper_name: selectedReport,
          lang_id: parseInt(language),
          sales_id:
            selectedList.length > 0
              ? selectedList.map((item) => item.value)
              : undefined,
          search: searchWord,
          active: activeStatus,
        },
      });
      if (res.code === 200) {
        let data = res.data;
        const workbook = XLSX.utils.book_new();
        let sales_people = selectedList || [];
        if (sales_people.length === 0) {
          sales_people.push({
            label: localStorage.getItem("name"),
            value: data[0].sales_person_id,
          });
        }
      
        // --- Individual sheets ---
        sales_people.forEach((salesPerson) => {
          const sheetData = [];
          const salespersonMarketData = data.filter(
            (item) => item.sales_person_id === salesPerson.value
          ); // Filter data for the salesperson
      
          sheetData.push([
            "Client Name",
            ...Array.from({ length: 12 }, (_, i) => [
              `${months[i]} Camps`,
              `${months[i]} Insertions`,
              `${months[i]} Amount`,
              `${months[i]} W2N CPD Camps`,
              `${months[i]} W2N CPD Inserts`,
              `${months[i]} W2N CPD Amount`,
              `${months[i]} W2N CPM Camps`,
              `${months[i]} W2N CPM Inserts`,
              `${months[i]} W2N CPM Amount`,
            ]).flat(),
            "Total Camps",
            "Total Insertions",
            "Total Spent",
            "Total CPD W2N Camps",
            "Total CPD W2n Inserts",
            "Total CPD W2N Spent",
            "Total CPM W2N Camps",
            "Total CPM W2n Inserts",
            "Total CPM W2N Spent",
          ]);
      
          salespersonMarketData.forEach((item) => {
            const row = [
              item.brand_name,
              ...Array.from({ length: 12 }, (_, i) => {
                const trackerData = getTrackerSpend(item.data, selectedYear, i + 1);
                const w2ncpdtrackerData = getTrackerSpend(
                  item.w2ndata,
                  selectedYear,
                  i + 1,
                  "CPD"
                );
                const w2ncpmtrackerData = getTrackerSpend(
                  item.w2ndata,
                  selectedYear,
                  i + 1,
                  "CPM"
                );
                return [
                  trackerData.dates_count,
                  trackerData.count,
                  trackerData.amountinr,
                  w2ncpdtrackerData.dates_count,
                  w2ncpdtrackerData.count,
                  w2ncpdtrackerData.amountinr,
                  w2ncpmtrackerData.dates_count,
                  w2ncpmtrackerData.count,
                  w2ncpmtrackerData.amountinr,
                ];
              }).flat(),
              calculateCount(item.data, "dates_count"),
              calculateCount(item.data, "count"),
              calculateCount(item.data, "amount"),
              calculateCount(item.w2ndata, "dates_count", "CPD"),
              calculateCount(item.w2ndata, "count", "CPD"),
              calculateCount(item.w2ndata, "amount", "CPD"),
              calculateCount(item.w2ndata, "dates_count", "CPM"),
              calculateCount(item.w2ndata, "count", "CPM"),
              calculateCount(item.w2ndata, "amount", "CPM"),
            ];
            sheetData.push(row);
          });
          const totalRow = ["TOTAL"];
          for (let col = 1; col < sheetData[0].length; col++) {
            const sum = sheetData
              .slice(1) // ignore header row
              .reduce((acc, row) => acc + (Number(row[col]) || 0), 0);
            totalRow.push(sum);
          }
          sheetData.push(totalRow);
        
          const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
          let match = salesPerson.label.match(/^(.+?)\(\s*(.+?)\s*\)$/);
          let SaleTitleName = "";
          if (match) {
            SaleTitleName = match[1];
          }
          let sheetName = `${SaleTitleName?.slice(0, 25) || SaleTitleName}_${salesPerson.value}`;
          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            sheetName
          );
        });
      
        // --- COMBINED SHEET: add this code here ---
        const combinedSheetData = [];
        combinedSheetData.push([
          "Sales Person Name",
          "Client Name",
          ...Array.from({ length: 12 }, (_, i) => [
            `${months[i]} Camps`,
            `${months[i]} Insertions`,
            `${months[i]} Amount`,
            `${months[i]} W2N CPD Camps`,
            `${months[i]} W2N CPD Inserts`,
            `${months[i]} W2N CPD Amount`,
            `${months[i]} W2N CPM Camps`,
            `${months[i]} W2N CPM Inserts`,
            `${months[i]} W2N CPM Amount`,
          ]).flat(),
          "Total Camps",
          "Total Insertions",
          "Total Spent",
          "Total CPD W2N Camps",
          "Total CPD W2N Inserts",
          "Total CPD W2N Spent",
          "Total CPM W2N Camps",
          "Total CPM W2N Inserts",
          "Total CPM W2N Spent",
        ]);
      
        sales_people.forEach((salesPerson) => {
          const salespersonMarketData = data.filter(
            (item) => item.sales_person_id === salesPerson.value
          );
        
          if (salespersonMarketData.length === 0) {
            // No data for this salesperson → push empty row with zeros
            const emptyRow = [
              salesPerson.label,
              "No Data", // client name placeholder
              ...Array(combinedSheetData[0].length - 2).fill(0) // fill all numeric cols with 0
            ];
            combinedSheetData.push(emptyRow);
          } else {
            salespersonMarketData.forEach((item) => {
              const row = [
                salesPerson.label,
                item.brand_name,
                ...Array.from({ length: 12 }, (_, i) => {
                  const trackerData = getTrackerSpend(item.data, selectedYear, i + 1);
                  const w2ncpdtrackerData = getTrackerSpend(
                    item.w2ndata,
                    selectedYear,
                    i + 1,
                    "CPD"
                  );
                  const w2ncpmtrackerData = getTrackerSpend(
                    item.w2ndata,
                    selectedYear,
                    i + 1,
                    "CPM"
                  );
                  return [
                    trackerData.dates_count,
                    trackerData.count,
                    trackerData.amountinr,
                    w2ncpdtrackerData.dates_count,
                    w2ncpdtrackerData.count,
                    w2ncpdtrackerData.amountinr,
                    w2ncpmtrackerData.dates_count,
                    w2ncpmtrackerData.count,
                    w2ncpmtrackerData.amountinr,
                  ];
                }).flat(),
                calculateCount(item.data, "dates_count"),
                calculateCount(item.data, "count"),
                calculateCount(item.data, "amount"),
                calculateCount(item.w2ndata, "dates_count", "CPD"),
                calculateCount(item.w2ndata, "count", "CPD"),
                calculateCount(item.w2ndata, "amount", "CPD"),
                calculateCount(item.w2ndata, "dates_count", "CPM"),
                calculateCount(item.w2ndata, "count", "CPM"),
                calculateCount(item.w2ndata, "amount", "CPM"),
              ];
              combinedSheetData.push(row);
            });
          }
        });
        
      
        const totalRow = ["TOTAL", ""];
        for (let col = 2; col < combinedSheetData[0].length; col++) {
          const sum = combinedSheetData
            .slice(1)
            .reduce((acc, row) => acc + (Number(row[col]) || 0), 0);
          totalRow.push(sum);
        }
        combinedSheetData.push(totalRow);
      
        const combinedWorksheet = XLSX.utils.aoa_to_sheet(combinedSheetData);
        XLSX.utils.book_append_sheet(workbook, combinedWorksheet, "All Salespersons");
      
      
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "buffer",
        });
        const excelBlob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        saveAs(excelBlob, "salespersons_data.xlsx");
      }
      else {
        Toast("error", "Something went wrong");
      }
    } catch (error) {
      console.log(error);
    }

    // Headers

    // Data Rows
  };
  const handledownload = ()=>{
    if(!compareYear)
    {
      downLoadData();
    }
    else
    {
      comparedownload();
    }
  }
  const onSlSalesChange = (selected) => {
    setSelectedList(selected || []);
    localStorage.setItem(
      "selectedSalesList",
      JSON.stringify(selected.map((item) => item.value))
    );
    // if(salesPerson_id !== -1){
    setSalesPerson_id(
      salesUsersList?.length > 1
        ? selected[selected.length - 1]?.value || -1
        : -1
    );
    document
      .getElementById(`${selected[selected.length - 1]?.value}`)
      .scrollIntoView({ behavior: "smooth" });
    // }
  };
  const salesTabChange = async (sales_id) => {
    setMarketSpend([]);
    setSalesPerson_id(sales_id);
  };

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  const handleRemove = (event) => {
    const sales_person_id = event;
    let tempArray = selectedList.filter(item => item.value !== +sales_person_id)
    setSelectedList(tempArray)
    let slideToId = salesPerson_id
    if(+sales_person_id === salesPerson_id){
      setSalesPerson_id(tempArray[0].value)
      slideToId = tempArray[0].value
    }
    localStorage.setItem("selectedSalesList", JSON.stringify(tempArray.map(item => item.value)))
    document?.getElementById(slideToId)?.scrollIntoView({ behavior: "smooth" });
  }

  const handleNewUsrTypChange = (new_user_type) => {
    try {
      setNewUserTypeInfilter(new_user_type)
      let filteredArray = salesUsersList
      if(searchFilter){
        filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(searchFilter))
      }
      if(+new_user_type){
        filteredArray = filteredArray.filter(item => +item.new_user_type === +new_user_type)
      }
      setTempSalesUsersList(filteredArray)
      setFilterActiveLetters([...new Set(
        filteredArray.map((item) => {
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )])
    } catch (error) {
      console.error("Error @ handleNewUsrTypChange", error)
    }
  }

  const closeUsersFilter = () => {
      try {
        if (selectedList.length === 0) { Toast("error", "Select Atleast a User") }
        else { setSalesPerson_id(selectedList[0].value); setShowUsersFilter(false) }
      } catch (error) {
        console.error("Error @ closeUsersFilter", error)
      }
    }

    const startResize = (e, columnKey) => {
      e.preventDefault();
      const startX = e.clientX;
      const startWidth = columnWidths[columnKey] || e.target.parentElement.offsetWidth;
    
      const onMouseMove = (e) => {
        const newWidth = startWidth + (e.clientX - startX);
        setColumnWidths((prev) => ({
          ...prev,
          [columnKey]: Math.max(newWidth, 10), // minimum width
        }));
      };
    
      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };
    
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    };

    const handleSortByHeader = (type, column, dataNeedToSorted) => {
      let tempSortOrder = sortOn.sortByType === type && sortOn.sortByColumn === column ? 
                      (sortOn.sortOrder === 'asc' ? 'desc' : 'asc') : 'desc'
      setSortOn({
        sortByType: type,
        sortByColumn: column,
        sortOrder: tempSortOrder,
        dataNeedToSorted
      })
      if(!dataNeedToSorted)
        marketSpend.sort((a,b) => {
          let aValue = calculateCount((type === 'newspaper' ? a.data : a.w2ndata) || [], column, type !== 'newspaper' ? type : null)
          let bValue = calculateCount((type === 'newspaper' ? b.data : b.w2ndata) || [], column, type !== 'newspaper' ? type : null)
          if(tempSortOrder === 'asc')
              return aValue - bValue
          else
            return bValue - aValue
        })
      else{
        mergedData.sort((a,b) => {
          let aValue = calculateCount((type === 'newspaper' ? a[dataNeedToSorted]?.data : a[dataNeedToSorted]?.w2ndata) || [], column, type !== 'newspaper' ? type : null)
          let bValue = calculateCount((type === 'newspaper' ? b[dataNeedToSorted]?.data : b[dataNeedToSorted]?.w2ndata) || [], column, type !== 'newspaper' ? type : null)
          if(tempSortOrder === 'asc')
              return aValue - bValue
          else
            return bValue - aValue
        })
      }
    }

  // useEffect(() =>{
  //   if(OpsSales.type !== "user")
  //     setAll(false)
  // }, [OpsSales.type])
  return (
    <div>
      <div>
      <h3 className="mb-3">Market Spend Tracker</h3>
      <div className="d-flex gap-3 items-center flex-wrap-reverse">
        <div>
          <p className="font-semibold mb-1 text-xs">Report Type</p>
          <div className="d-flex gap-2 items-center">
            <div className="custom-radio-img">
              <input
                type="radio"
                id="all"
                checked={selectedReport === "All"}
                onChange={() => setSelectedReport("All")}
                value="All"
                aria-label="All"
              />
              <label
                htmlFor="all"
                className="rounded-full hover:cursor-pointer"
              >
                <img className="w-8" src={AllSvg} alt="All Logo" />
              </label>
            </div>
            {filteredNewspapers.map((np) => (
              <div className="custom-radio-img" key={np.id}>
                <input
                  type="radio"
                  id={np.id.toLowerCase()}
                  checked={selectedReport === np.name}
                  onChange={() => setSelectedReport(np.name)}
                  value={np.name}
                  aria-label={np.name}
                />
                <label
                  htmlFor={np.id.toLowerCase()}
                  className="rounded-full hover:cursor-pointer"
                  title={np.name}
                >
                  {/* <div className="w-6 h-6 d-flex justify-center items-center rounded-full">{np.name.slice(0, 2).toUpperCase()}</div> */}
                  <img className="w-8 h-8" src={np.logo} alt={np.name} />
                </label>
              </div>
            ))}
          </div>
        </div>
        <div className="market-share-filters">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="flexSwitchCheckChecked"
              checked={activeStatus}
              onChange={() => {
                setActiveStatus(!activeStatus);
              }}
            />
            <label class="form-check-label" for="flexSwitchCheckChecked">
              {activeStatus ? "Active" : "Inactive"}
            </label>
          </div>
          <div className="d-flex items-end select-field">
            {" "}
            <YearCalendar startYear={2023} endYear={2100}></YearCalendar>{" "}
          </div>
          <div>
            <select
              className="form-select select-field"
              onChange={handleLanguage}
              value={language}
            >
              <option value={"0"}>All Languages</option>
              {languageOptions.map((lang) => (
                <option key={lang.id} value={lang.value}>
                  {lang.label}
                </option>
              ))}
            </select>
          </div>

          {/* {salesUsersList?.length > 1 ? (
          <Select
            type="text"
            className={`mobHide max-w-[89%]`}
            name="sales_person_id"
            placeholder="Sales Person"
            value={selectedList}
            onChange={(selected) => {
              onSlSalesChange(selected);
            }}
            options={[...salesUsersList]}
            isMulti
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999, // or any other high value to ensure it is above other elements
              }),
              menuList: (provided) => ({
                ...provided,
                zIndex: 9999, // apply z-index to menuList if needed
              }),
            }}
          />
        ) : null} */}
        <div
            className="w-6 h-6 bg-gray-200 hover:text-sky-400 rounded-md cursor-pointer items-center justify-center flex"
            onClick={handledownload}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
          <div className="marketcounts">
            <div className="count">
              <b>Count-</b>
              <span>{CountAmount.count}</span>
            </div>

            <div className="spent">
              <b>spent-</b>
              <span>{CountAmount.amount}</span>
            </div>

          </div>

          <div className="d-flex items-end gap-4">
          <b>CompareYear</b>

          {/* Case 1: Show ✅ if nothing selected and calendar is hidden */}
          {!showcomparecalendar && compareYear === null && (
            <button title="Add Compare Year" onClick={() => setshowcomparecalendar(true)}>✅</button>
          )}

          {/* Case 2: Show YearCalendar if toggled */}
          {showcomparecalendar && (
            <span>
              <YearCalendar
                startYear={2023}
                endYear={2100}
                value={compareYear}
                onChange={(year) => setCompareYear(year)}
                compareYear={true}
              />
            </span>
          )}

          {/* Case 3: Show selected year + ❌ button */}
          {compareYear !== null && showcomparecalendar && (
            <span className="d-flex items-center gap-2">
              <button
                title="Remove Compare Year"
                onClick={() => {
                  setCompareYear(null);
                  setshowcomparecalendar(false);
                }}
              >
                ❌
              </button>
            </span>
          )}
    </div>

          {salesUsersList?.length > 1 ? <div className="select-sales-users ml-auto" onClick={() => { setShowUsersFilter(true) }}>
            Select Users
          </div> : null}
          {/* <div className="mobileOnly">
          <img
            src={filterSvg}
            className="ml-auto w-6"
            onClick={() => setShowFilter(true)}
            alt="filter"
          ></img>
        </div> */}
        </div>
      </div>
      <SlTabGroup>
        {!(
          salesUsersList?.length > 1
        ) && (
          <SlTab
            onClick={() => {
              salesTabChange(-1);
            }}
            slot="nav"
            panel="general"
            active={salesPerson_id === -1}
          >
            {localStorage.getItem("name")}
          </SlTab>
        )}
        {selectedList.map((item) => {
          return (
            <SlTab
              slot="nav"
              closable={selectedList.length > 1}
              onSlClose={() => handleRemove(item.value)}
              panel={item.value}
              onClick={() => {
                salesTabChange(item.value);
              }}
              active={salesPerson_id === item.value}
              id={`${item.value}`}
            >
              {item.label}
            </SlTab>
          );
        })}
      </SlTabGroup>
      {!compareYear && (<ScrollContainer>
        <table class="splScrollableMarket table table-bordered">
          <tr className="h-[3.8rem]">
            <th className="mobHide stick">#</th>
            <th className="stick relative" style={columnWidths.client ? { width: columnWidths.client } : undefined}>
               Client Name
               <div
                className="absolute right-0 top-0 h-full w-2 cursor-col-resize bg-transparent hover:bg-gray-300"
                style={{ transform: "translateX(50%)", padding: "0 !important", border: "0"}} // Half outside the cell
                onMouseDown={(e) => startResize(e, "client")}
                onDoubleClick={() => {
                  setColumnWidths(prev => {
                    const updated = { ...prev };
                    delete updated["client"]; // remove that column key
                    return updated;
                  });
                }}
              ></div>
            </th>
            <th rowspan="99" class="vTop relative" style={columnWidths["vTop"] ? { width: columnWidths["vTop"]} : undefined}>
              <div class="scrollableArea" style={columnWidths["vTop"] ? { width: columnWidths["vTop"], "max-width": "100%"} : undefined}>
                <table>{console.log(selectedReport)}
                  <tr>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}> January</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">
                      {" "}
                      February
                    </th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}> March</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">
                      {" "}
                      April
                    </th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}> May</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">
                      {" "}
                      June
                    </th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}> July</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">
                      {" "}
                      August
                    </th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}> September</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">
                      {" "}
                      October
                    </th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}> November</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">
                      {" "}
                      December
                    </th>
                  </tr>
                  <tr>
                    {Array.from({ length: 12 }).map((_, index) => (
                      <>
                        {selectedReport !== "Way2news" ? (
                          <th
                            className={`${
                              index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                            }  brd-right`}
                            colSpan={3}
                            rowSpan={2}
                          >
                            {/* {selectedReport === 'All' ? <img className="w-8 h-8" src={AllSvg} alt={'All'} /> :  <img className="w-8 h-8" src={newspaperData.find(item => item.name === selectedReport)?.logo} alt={newspaperData.find(item => item.newspaper_name === selectedReport)?.name} />} */}
                            {selectedReport}
                          </th>
                        ) : null}
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                          colSpan={6}
                        >
                          {/* <img className="w-8 h-8" src={newspaperData.find(item => item.name === 'Way2news')?.logo} alt={'Way2news'} /> */}
                          Way2News
                        </th>
                      </>
                    ))}
                  </tr>
                  <tr>
                    {Array.from({ length: 12 }).map((_, index) => (
                      <React.Fragment key={index}>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                          colSpan={3}
                        >
                          CPD
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                          colSpan={3}
                        >
                          CPM
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>

                  <tr>
                    {Array.from({ length: 12 }).map((_, index) => (
                      <React.Fragment key={index}>
                        {selectedReport !== "Way2news" ? (
                          <>
                            <th
                              className={`${
                                index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                              }`}
                            >
                              C
                            </th>
                            <th
                              className={`${
                                index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                              }`}
                            >
                              I
                            </th>
                            <th
                              className={`${
                                index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                              }  brd-right`}
                            >
                              &#8377;
                            </th>
                          </>
                        ) : null}
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          C
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          I
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          &#8377;
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          C
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          I
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          &#8377;
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>
                  {marketSpend?.map((item, index) => {
                    return (
                      <tr className="h-8">
                        {Array.from({ length: 12 }).map((_, index) => {
                          const trackerData = getTrackerSpend(
                            item.data,
                            selectedYear,
                            index + 1,
                            ""
                          );
                          const w2ncpmtrackerData = getTrackerSpend(
                            item.w2ndata,
                            selectedYear,
                            index + 1,
                            "CPM"
                          );
                          const w2ncpdtrackerData = getTrackerSpend(
                            item.w2ndata,
                            selectedYear,
                            index + 1,
                            "CPD"
                          );
                          const year = new Date(selectedYear).getFullYear();
                          const d = new Date(year, index + 1, 0);
                          const startDate = `${year}-${index + 1}-1`;
                          const endDate = `${year}-${index + 1}-${d.getDate()}`;
                          const previousTrackerSpend =
                            index > 0
                              ? getTrackerSpend(item.data, selectedYear, index)
                              : {
                                  count: 0,
                                  amount: 0,
                                  dates_count: 0,
                                  amountinr: 0,
                                };
                          const w2ncpmpreviousTrackerSpend =
                            index > 0
                              ? getTrackerSpend(
                                  item.w2ndata,
                                  selectedYear,
                                  index,
                                  "CPM"
                                )
                              : {
                                  count: 0,
                                  amount: 0,
                                  dates_count: 0,
                                  amountinr: 0,
                                };
                          const w2ncpdpreviousTrackerSpend =
                            index > 0
                              ? getTrackerSpend(
                                  item.w2ndata,
                                  selectedYear,
                                  index,
                                  "CPD"
                                )
                              : {
                                  count: 0,
                                  amount: 0,
                                  dates_count: 0,
                                  amountinr: 0,
                                };
                          return trackerData.count !== 0 ||
                            w2ncpdtrackerData.count !== 0 ||
                            w2ncpmtrackerData.count !== 0 ? (
                            <React.Fragment key={index}>
                              {selectedReport !== "Way2news" ? (
                                <>
                                  <td
                                    className={`${
                                      index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                    }`}
                                  >
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        previousTrackerSpend.dates_count >
                                        trackerData.dates_count
                                          ? "text-red-600"
                                          : "text-green-500"
                                      }`}
                                      name={`${
                                        previousTrackerSpend.dates_count >
                                        trackerData.dates_count
                                          ? "arrow-down"
                                          : "arrow-up"
                                      }`}
                                    ></SlIcon>{" "}
                                    {trackerData.dates_count}
                                  </td>
                                  <td
                                    className={`${
                                      index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                    }`}
                                  >
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        previousTrackerSpend.count >
                                        trackerData.count
                                          ? "text-red-600"
                                          : "text-green-500"
                                      }`}
                                      name={`${
                                        previousTrackerSpend.count >
                                        trackerData.count
                                          ? "arrow-down"
                                          : "arrow-up"
                                      }`}
                                    ></SlIcon>{" "}
                                    {trackerData.count}
                                  </td>
                                  <td
                                    className={`${
                                      index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                    } relative brd-right`}
                                    onClick={() => {
                                      setFetchW2nCampaign_type(null)
                                      setFetchW2n(false);
                                      setBrand(item.brand_id);
                                      setB2BShow(true);
                                      setDate({
                                        startDate: startDate,
                                        endDate: endDate,
                                      });
                                    }}
                                  >
                                    <span
                                      className={`${
                                        parseInt(
                                          previousTrackerSpend.amountinr
                                        ) < parseInt(trackerData.amountinr)
                                          ? "greenSpend"
                                          : "redSpend"
                                      }`}
                                      title={trackerData.amountinr}
                                    >
                                      {trackerData.amount}
                                    </span>
                                    {trackerData.amount.includes("cr") ? (
                                      <span className="absolute text-[#2DB27A] top-1 right-1">
                                        <sl-icon name="star-fill"></sl-icon>
                                      </span>
                                    ) : null}
                                  </td>
                                </>
                              ) : null}
                              <td
                                className={`${
                                  index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                }`}
                              >
                                <SlIcon
                                  library="lucide"
                                  className={`${
                                    w2ncpdpreviousTrackerSpend.dates_count >
                                    w2ncpdtrackerData.dates_count
                                      ? "text-red-600"
                                      : "text-green-500"
                                  }`}
                                  name={`${
                                    w2ncpdpreviousTrackerSpend.dates_count >
                                    w2ncpdtrackerData.dates_count
                                      ? "arrow-down"
                                      : "arrow-up"
                                  }`}
                                ></SlIcon>{" "}
                                {w2ncpdtrackerData.dates_count}
                              </td>
                              <td
                                className={`${
                                  index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                }`}
                              >
                                <SlIcon
                                  library="lucide"
                                  className={`${
                                    w2ncpdpreviousTrackerSpend.count >
                                    w2ncpdtrackerData.count
                                      ? "text-red-600"
                                      : "text-green-500"
                                  }`}
                                  name={`${
                                    w2ncpdpreviousTrackerSpend.count >
                                    w2ncpdtrackerData.count
                                      ? "arrow-down"
                                      : "arrow-up"
                                  }`}
                                ></SlIcon>{" "}
                                {w2ncpdtrackerData.count}
                              </td>
                              <td
                                className={`${
                                  index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                } relative`}
                                onClick={() => {
                                  setFetchW2nCampaign_type('CPD')
                                  setFetchW2n(true);
                                  setBrand(item.brand_id);
                                  setB2BShow(true);
                                  setDate({
                                    startDate: startDate,
                                    endDate: endDate,
                                  });
                                }}
                              >
                                <span
                                  className={`${
                                    parseInt(
                                      w2ncpdpreviousTrackerSpend.amountinr
                                    ) < parseInt(w2ncpdtrackerData.amountinr)
                                      ? "greenSpend"
                                      : "redSpend"
                                  }`}
                                  title={w2ncpdtrackerData.amountinr}
                                >
                                  {w2ncpdtrackerData.amount}
                                </span>
                                {w2ncpdtrackerData.amount.includes("cr") ? (
                                  <span className="absolute text-[#2DB27A] top-1 right-1">
                                    <sl-icon name="star-fill"></sl-icon>
                                  </span>
                                ) : null}
                              </td>
                              <td
                                className={`${
                                  index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                }`}
                              >
                                <SlIcon
                                  library="lucide"
                                  className={`${
                                    w2ncpmpreviousTrackerSpend.dates_count >
                                    w2ncpmtrackerData.dates_count
                                      ? "text-red-600"
                                      : "text-green-500"
                                  }`}
                                  name={`${
                                    w2ncpmpreviousTrackerSpend.dates_count >
                                    w2ncpmtrackerData.dates_count
                                      ? "arrow-down"
                                      : "arrow-up"
                                  }`}
                                ></SlIcon>{" "}
                                {w2ncpmtrackerData.dates_count}
                              </td>
                              <td
                                className={`${
                                  index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                }`}
                              >
                                <SlIcon
                                  library="lucide"
                                  className={`${
                                    w2ncpmpreviousTrackerSpend.count >
                                    w2ncpmtrackerData.count
                                      ? "text-red-600"
                                      : "text-green-500"
                                  }`}
                                  name={`${
                                    w2ncpmpreviousTrackerSpend.count >
                                    w2ncpmtrackerData.count
                                      ? "arrow-down"
                                      : "arrow-up"
                                  }`}
                                ></SlIcon>{" "}
                                {w2ncpmtrackerData.count}
                              </td>
                              <td
                                className={`${
                                  index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                } relative`}
                                onClick={() => {
                                  setFetchW2nCampaign_type('CPM')
                                  setFetchW2n(true);
                                  setBrand(item.brand_id);
                                  setB2BShow(true);
                                  setDate({
                                    startDate: startDate,
                                    endDate: endDate,
                                  });
                                }}
                              >
                                <span
                                  className={`${
                                    parseInt(
                                      w2ncpmpreviousTrackerSpend.amountinr
                                    ) < parseInt(w2ncpmtrackerData.amountinr)
                                      ? "greenSpend"
                                      : "redSpend"
                                  }`}
                                  title={w2ncpmtrackerData.amountinr}
                                >
                                  {w2ncpmtrackerData.amount}
                                </span>
                                {w2ncpmtrackerData.amount.includes("cr") ? (
                                  <span className="absolute text-[#2DB27A] top-1 right-1">
                                    <sl-icon name="star-fill"></sl-icon>
                                  </span>
                                ) : null}
                              </td>
                            </React.Fragment>
                          ) : (
                            <td colSpan={selectedReport === "Way2news" ? 6 : 9} key={index} className="text-center">
                              <div className="d-flex justify-center">
                                <img src={sundayIcon} alt="" />
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </table>
              </div>
              {/* 👇 Resizer handle */}
              <div
                className="absolute right-0 top-0 h-full w-2 cursor-col-resize bg-transparent hover:bg-gray-300"
                style={{padding: "0 !important", border: "0", transform: "translateX(50%)"}}
                onMouseDown={(e) => startResize(e, "vTop")}
                onDoubleClick={() => {
                  setColumnWidths(prev => {
                    const updated = { ...prev };
                    delete updated["vTop"]; // remove that column key
                    return updated;
                  });
                }}
              ></div>
            </th>
            <th rowspan="99" class="vTop2" >
              <table className="countsTable">
                <tr>
                  <th colSpan={selectedReport === "Way2news" ? 2 :3}>Total Camps </th>
                  <th colSpan={selectedReport === "Way2news" ? 2 :3}>Total Insertions</th>
                  <th colSpan={selectedReport === "Way2news" ? 2 :3}>Total Spent</th>
                </tr>
                <tr>
                  {selectedReport !== "Way2news" ? <th rowSpan={2}>
                    <div className="d-flex justify-center">
                    {selectedReport}
                    <div className="top-3 right-2 group-hover:block">
                  <SlTooltip content="sort">
                    <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader('newspaper', 'dates_count')} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "dates_count" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                  </SlTooltip>
                  </div>
                  </div>
                    </th> : null}
                  <th colSpan={2}>W2N</th>
                  {selectedReport !== "Way2news" ? <th rowSpan={2}>
                  <div className="d-flex justify-center">
                    {selectedReport}
                    <div className="top-3 right-2 group-hover:block">
                  <SlTooltip content="sort">
                    <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("newspaper", "count")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "count" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                  </SlTooltip>
                  </div>
                  </div>
                    </th> : null}
                  <th colSpan={2}>W2N</th>
                  {selectedReport !== "Way2news" ? <th rowSpan={2}>
                  <div className="d-flex justify-center">
                    {selectedReport}
                    <div className="top-3 right-2 group-hover:block">
                  <SlTooltip content="sort">
                    <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("newspaper", "amount")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "amount" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                  </SlTooltip>
                  </div>
                  </div>
                    </th> : null}
                  <th colSpan={2}>W2N</th>
                </tr>
                <tr>
                  <th>
                  <div className="d-flex justify-center">
                    CPD
                    <div className="top-3 right-2 group-hover:block">
                    <SlTooltip content="sort">
                      <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD" , "dates_count")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "dates_count" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                    </SlTooltip>
                    </div>
                    </div>
                  </th>
                  <th>
                  <div className="d-flex justify-center">
                    CPM
                    <div className="top-3 right-2 group-hover:block">
                    <SlTooltip content="sort">
                      <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "dates_count")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "dates_count" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                    </SlTooltip>
                    </div>
                    </div>
                  </th>
                  <th>
                  <div className="d-flex justify-center">
                    CPD
                    <div className="top-3 right-2 group-hover:block">
                    <SlTooltip content="sort">
                      <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD", "count")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "count" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                    </SlTooltip>
                    </div>
                    </div>
                  </th>
                  <th>
                  <div className="d-flex justify-center">
                    CPM
                    <div className="top-3 right-2 group-hover:block">
                    <SlTooltip content="sort">
                      <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "count")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "count" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                    </SlTooltip>
                    </div>
                    </div>
                  </th>
                  <th>
                  <div className="d-flex justify-center">
                    CPD
                    <div className="top-3 right-2 group-hover:block">
                    <SlTooltip content="sort">
                      <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD", "amount")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "amount" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                    </SlTooltip>
                    </div>
                    </div>
                  </th>
                  <th>
                  <div className="d-flex justify-center">
                    CPM
                    <div className="top-3 right-2 group-hover:block">
                    <SlTooltip content="sort">
                      <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "amount")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "amount" ? 'arrow-down' : 'arrow-up'}></SlIcon>
                    </SlTooltip>
                    </div>
                    </div>
                  </th>
                </tr>
                {marketSpend.map((item, index) => {
                  return (
                    <tr key={item.brand_id} className="h-8">
                      {selectedReport !== "Way2news" ?<td>{calculateCount(item.data, "dates_count")}</td> : null}
                      <td>{calculateCount(item.w2ndata, "dates_count", "CPD")}</td>
                      <td>{calculateCount(item.w2ndata, "dates_count", "CPM")}</td>
                      {selectedReport !== "Way2news" ?<td>{calculateCount(item.data, "count")}</td> : null}
                      <td>{calculateCount(item.w2ndata, "count", "CPD")}</td>
                      <td>{calculateCount(item.w2ndata, "count", "CPM")}</td>
                      {selectedReport !== "Way2news" ?<td title={calculateCount(item.data, "amount")}>
                        {formatAmount(calculateCount(item.data, "amount"))}
                      </td> : null}
                      <td title={calculateCount(item.w2ndata, "amount", "CPD")}>
                        {formatAmount(calculateCount(item.w2ndata, "amount", "CPD"))}
                      </td>
                      <td title={calculateCount(item.w2ndata, "amount", "CPM")}>
                        {formatAmount(calculateCount(item.w2ndata, "amount", "CPM"))}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </th>
          </tr>
          {marketSpend?.length && !loader ? (
            <>
              {marketSpend.map((item, index) => {
                return (
                  <tr key={item.brand_id} className="h-8">
                    <td className="mobHide stick">{index + 1}</td>
                    <td className="truncate stick" title={item.brand_name} style={columnWidths.client ? { "max-width": columnWidths.client, overflow: "hidden" } : undefined}>
                      {item.brand_name}
                    </td>
                  </tr>
                );
              })}
            </>
          ) : !marketSpend?.length && !loader ? (
            <NoDataFound colspan="5" />
          ) : (
            <TableLoader colspan="5" />
          )}
        </table>
      </ScrollContainer>)}
      {B2BShow && (
        <B2BPreview
          show={B2BShow}
          language={language}
          brand={brand}
          setShow={setB2BShow}
          newspaper={selectedReport}
          date={date}
          salesPerson_id={salesPerson_id}
          fetchW2n={fetchW2n}
          fetchAllNews={!fetchW2n}
          fetchW2nCampaign_type={fetchW2n ? fetchW2nCampaign_type : null}
        />
      )}

      {/* <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => {}}
        // style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="flex items-center gap-3 flex-wrap justify-between">
            <div className="w-full d-flex items-end">
              {" "}
              <YearCalendar startYear={2023} endYear={2100}></YearCalendar>{" "}
            </div>
            <div className="w-full">
              <select
                className="form-select"
                onChange={handleLanguage}
                value={language}
              >
                <option value={"0"}>All Languages</option>
                {languageOptions.map((lang) => (
                  <option key={lang.id} value={lang.value}>
                    {lang.label}
                  </option>
                ))}
              </select>
            </div>
            {salesUsersList?.length > 1 ? (
              <div>
                <Select
                  type="text"
                  className="w-full"
                  name="sales_person_id"
                  placeholder="Sales Person"
                  value={selectedList}
                  onChange={(selected) => {
                    onSlSalesChange(selected);
                  }}
                  options={[...salesUsersList]}
                  isMulti
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999, // or any other high value to ensure it is above other elements
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      zIndex: 9999, // apply z-index to menuList if needed
                    }),
                  }}
                />
              </div>
            ) : null}
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer> */}
      {showUsersFilter ? <div className="usersMultiSelect" onClick={() => closeUsersFilter()}>
        <div class="popupuserlist" onClick={(e) => e.stopPropagation()}>
          <div class="userlist-header">
            <div class="alphabiticals">
              <ul>
                {alphabets.map(alphabet => {
                  return <li
                    onClick={() => scrollToSection(alphabet)}
                    className={`${filterActiveLetters.includes(alphabet) ? "" : "inactive"
                      }`}

                  >
                    {alphabet}
                  </li>
                })}

              </ul>
            </div>
            <ul class="new-user-type">
              <li key={0} onClick={() => { handleNewUsrTypChange(0) }}>
                <label className={+newUserTypeInfilter === 0 ? 'active' : ''} onClick={() => handleNewUsrTypChange(0)}>
                  All
                </label>
              </li>
              {BrandsTypes.filter(item => allowedNewUserTypes.includes(item.value)).map((item) => (
                <li key={item.value} onClick={() => { handleNewUsrTypChange(item.value) }}>
                  <label className={+newUserTypeInfilter === item.value ? 'active' : ''} onClick={() => handleNewUsrTypChange(item.value)}>
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
            <div class="searchbox">
              <input class="form-control" placeholder="search" value={searchFilter} onChange={(e) => {
                setSearchFilter(e.target.value)
                let tempString = e.target.value.toLowerCase()
                let filteredArray = salesUsersList
                if (newUserTypeInfilter) {
                  filteredArray = filteredArray.filter(item => item.new_user_type === newUserTypeInfilter)
                }
                if (tempString) {
                  filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(tempString))
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    filteredArray.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
                else {
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    salesUsersList.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
              }}
              />
            </div>
          </div>

          <div class="userlistbody">
            {filterActiveLetters.map(alphabet => {
              let filteredUsers = tempSalesUsersList.filter(item => item.label[0].toUpperCase() === alphabet)
              return (<div class="alphabiticalletterelement">
                <div class="alphabiticalletter" id={alphabet}>
                  <span>{alphabet}</span>
                </div>

                <div class="userlist">
                  <ul>
                    {filteredUsers.map(user =>
                      <li onClick={() => { if (!selectedList.find(item => item.value === user.value)) { setSelectedList([...selectedList, user]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.map(item => item.value), user.value])) } else { setSelectedList([...selectedList.filter(item => item.value !== user.value)]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.filter(item => item.value !== user.value)].map(item => item.value))) } }} className={selectedList.find(item => item.value === user.value) ? "active" : ""}>
                        {user.label}
                      </li>)}
                  </ul>
                </div>
              </div>)

            }
            )}
          </div>

          <div class="userlistfooter">
            <div class="btnuserdetails">
              <button class="selectall" type="button" onClick={() => { setSelectedList([]); localStorage.setItem('selectedSalesList', JSON.stringify([])) }}>Clear All</button>
              <button class="selectonebyone" type="button" onClick={() => { setSelectedList([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))]); localStorage.setItem("selectedSalesList", JSON.stringify([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))].map(item => item.value))) }}>Select All</button>
              <button class={`selectonebyone ${selectedList.length === 0 ? 'disabled' : ''}`} type="button" title={selectedList.length === 0 ? 'Select Atleast a User' : ''} onClick={() => closeUsersFilter()}>Apply</button>
            </div>
          </div>
          <button
            className="close-btn"
            onClick={() => closeUsersFilter()}
          >
            <img src={closeSvg} alt="close2" />
          </button>
        </div>
      </div> : null}
    {showdata && compareYear && <ScrollContainer>
        <table class="splScrollableMarket table table-bordered">
          <tr className="h-[3.8rem]">
            <th className="mobHide stick">#</th>
            <th  className="stick relative" style={columnWidths.client ? { width: columnWidths.client } : undefined}>
               Client Name
               <div
                className="absolute right-0 top-0 h-full w-2 cursor-col-resize bg-transparent hover:bg-gray-300"
                style={{ transform: "translateX(50%)", padding: "0 !important", border: "0"}} // Half outside the cell
                onMouseDown={(e) => startResize(e, "client")}
                onDoubleClick={() => {
                  setColumnWidths(prev => {
                    const updated = { ...prev };
                    delete updated["client"]; // remove that column key
                    return updated;
                  });
                }}
              ></div>
            </th>
            <th rowspan="99" class="vTop relative">
              <div class="scrollableArea"  style={columnWidths["vTop"] ? { width: columnWidths["vTop"], "max-width": "100%"} : undefined}>
                <table>{console.log(selectedReport)}
                <tr>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>January {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">January {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>February {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">February {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>March {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">March {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>April {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">April {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>May {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">May {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>June {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">June {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>July {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">July {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>August {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">August {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>September {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]" >September {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>October {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">October {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9}>November {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]" >November {new Date(selectedYear).getFullYear()}</th>

                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} >December {compareYear}</th>
                    <th colSpan={selectedReport === "Way2news" ? 6 : 9} className="bg-[#F6F6F6]">December {new Date(selectedYear).getFullYear()}</th>
                </tr>

                  <tr>
                    {Array.from({ length: 24 }).map((_, index) => (
                      <>
                        {selectedReport !== "Way2news" ? (
                          <th
                            className={`${
                              index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                            }  brd-right`}
                            colSpan={3}
                            rowSpan={2}
                          >
                            {/* {selectedReport === 'All' ? <img className="w-8 h-8" src={AllSvg} alt={'All'} /> :  <img className="w-8 h-8" src={newspaperData.find(item => item.name === selectedReport)?.logo} alt={newspaperData.find(item => item.newspaper_name === selectedReport)?.name} />} */}
                            {selectedReport}
                          </th>
                        ) : null}
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                          colSpan={6}
                        >
                          {/* <img className="w-8 h-8" src={newspaperData.find(item => item.name === 'Way2news')?.logo} alt={'Way2news'} /> */}
                          Way2News
                        </th>
                      </>
                    ))}
                  </tr>
                  <tr>
                    {Array.from({ length: 24 }).map((_, index) => (
                      <React.Fragment key={index}>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                          colSpan={3}
                        >
                          CPD
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                          colSpan={3}
                        >
                          CPM
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>

                  <tr>
                    {Array.from({ length: 24 }).map((_, index) => (
                      <React.Fragment key={index}>
                        {selectedReport !== "Way2news" ? (
                          <>
                            <th
                              className={`${
                                index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                              }`}
                            >
                              C
                            </th>
                            <th
                              className={`${
                                index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                              }`}
                            >
                              I
                            </th>
                            <th
                              className={`${
                                index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                              }  brd-right`}
                            >
                              &#8377;
                            </th>
                          </>
                        ) : null}
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          C
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          I
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          &#8377;
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          C
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          I
                        </th>
                        <th
                          className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"}`}
                        >
                          &#8377;
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>
                  {mergedData?.length && mergedData.map((item) => (
                    <tr key={item.brand_id} className="h-8">
                      {Array.from({ length: 12 }).map((_, index) => {
                        // Selected year
                        const trackerSelected = getTrackerSpend(
                          item.selected?.data,
                          selectedYear,
                          index + 1,
                          ""
                        );
                        const w2ncpdSelected = getTrackerSpend(
                          item.selected?.w2ndata,
                          selectedYear,
                          index + 1,
                          "CPD"
                        );
                        const w2ncpmSelected = getTrackerSpend(
                          item.selected?.w2ndata,
                          selectedYear,
                          index + 1,
                          "CPM"
                        );

                        // Compare year
                        const trackerCompare = getTrackerSpend(
                          item.compare?.data,
                          new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(),
                          index + 1,
                          ""
                        );
                        const w2ncpdCompare = getTrackerSpend(
                          item.compare?.w2ndata,
                          new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(),
                          index + 1,
                          "CPD"
                        );
                        const w2ncpmCompare = getTrackerSpend(
                          item.compare?.w2ndata,
                          new Date(compareYear, 0, 1, 0, 0, 0, 0).getTime(),
                          index + 1,
                          "CPM"
                        );
                         
                        const year = new Date(selectedYear).getFullYear();
                        const d = new Date(year, index + 1, 0);
                        const startDate = `${year}-${index + 1}-1`;
                        const endDate = `${year}-${index + 1}-${d.getDate()}`;

                        const compareYearMonth = compareYear; // like 2025
                        const compareMonthEnd = new Date(compareYearMonth, index + 1, 0); // last day of the month
                        const compareStartDate = `${compareYearMonth}-${index + 1}-1`; // first day of month
                        const compareEndDate = `${compareYearMonth}-${index + 1}-${compareMonthEnd.getDate()}`; // last day of month


                        // Determine if selected or compare has no data
                        const hasSelectedData =
                          trackerSelected.count > 0 ||
                          trackerSelected.dates_count > 0 ||
                          w2ncpdSelected.count > 0 ||
                          w2ncpmSelected.count > 0;

                        const hasCompareData =
                          trackerCompare.count > 0 ||
                          trackerCompare.dates_count > 0 ||
                          w2ncpdCompare.count > 0 ||
                          w2ncpmCompare.count > 0;

                        return (
                          <React.Fragment key={index}>
                            {/* Compare Year Metrics */}
                              {hasCompareData ? (
                                <>
                                  <td>
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        trackerCompare.dates_count > trackerSelected.dates_count
                                          ? "text-green-500"
                                          : "text-red-600"
                                      }`}
                                      name={`${
                                        trackerCompare.dates_count > trackerSelected.dates_count
                                          ? "arrow-up"
                                          : "arrow-down"
                                      }`}
                                    />{" "}
                                    {trackerCompare.dates_count}
                                  </td>
                                  <td>
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        trackerCompare.count > trackerSelected.count
                                          ? "text-green-500"
                                          : "text-red-600"
                                      }`}
                                      name={`${
                                        trackerCompare.count > trackerSelected.count
                                          ? "arrow-up"
                                          : "arrow-down"
                                      }`}
                                    />{" "}
                                    {trackerCompare.count}
                                  </td>
                                  <td
                                        className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"} relative brd-right`}
                                        onClick={() => {
                                          setFetchW2nCampaign_type(null);
                                          setFetchW2n(false);
                                          setBrand(item.brand_id);
                                          setB2BShow(true);
                                          setDate({
                                            startDate: compareStartDate,
                                            endDate: compareEndDate,
                                          });
                                        }}
                                      >
                                        <span
                                          className={`${
                                            (parseInt(trackerCompare.amountinr) || 0) > (parseInt(trackerSelected.amountinr) || 0)
                                              ? "greenSpend"
                                              : "redSpend"
                                          }`}
                                          title={trackerCompare.amountinr}
                                        >
                                          {trackerCompare.amount}
                                        </span>
                                        {trackerCompare.amount.includes("cr") && (
                                          <span className="absolute text-[#2DB27A] top-1 right-1">
                                            <sl-icon name="star-fill"></sl-icon>
                                          </span>
                                        )}
                                  </td>
                                  <td>
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        w2ncpdCompare.dates_count > w2ncpdSelected.dates_count
                                          ? "text-green-500"
                                          : "text-red-600"
                                      }`}
                                      name={`${
                                        w2ncpdCompare.dates_count > w2ncpdSelected.dates_count
                                          ? "arrow-up"
                                          : "arrow-down"
                                      }`}
                                    />{" "}
                                    {w2ncpdCompare.dates_count}
                                  </td>
                                  <td>
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        w2ncpdCompare.count > w2ncpdSelected.count
                                          ? "text-green-500"
                                          : "text-red-600"
                                      }`}
                                      name={`${
                                        w2ncpdCompare.count > w2ncpdSelected.count
                                          ? "arrow-up"
                                          : "arrow-down"
                                      }`}
                                    />{" "}
                                    {w2ncpdCompare.count}
                                  </td>
                                  <td
                                        className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"} relative brd-right`}
                                        onClick={() => {
                                          setFetchW2nCampaign_type('CPD');
                                          setFetchW2n(true);
                                          setBrand(item.brand_id);
                                          setB2BShow(true);
                                          setDate({ startDate: compareStartDate, endDate: compareEndDate });
                                        }}
                                      >
                                        <span
                                          className={`${
                                            (parseInt(w2ncpdCompare.amountinr) || 0) > (parseInt(w2ncpdSelected.amountinr) || 0)
                                              ? "greenSpend"
                                              : "redSpend"
                                          }`}
                                          title={w2ncpdCompare.amountinr}
                                        >
                                          {w2ncpdCompare.amount}
                                        </span>
                                        {w2ncpdCompare.amount.includes("cr") && (
                                          <span className="absolute text-[#2DB27A] top-1 right-1">
                                            <sl-icon name="star-fill"></sl-icon>
                                          </span>
                                        )}
                                  </td>
                                  <td>
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        w2ncpmCompare.dates_count > w2ncpmSelected.dates_count
                                          ? "text-green-500"
                                          : "text-red-600"
                                      }`}
                                      name={`${
                                        w2ncpmCompare.dates_count > w2ncpmSelected.dates_count
                                          ? "arrow-up"
                                          : "arrow-down"
                                      }`}
                                    />{" "}
                                    {w2ncpmCompare.dates_count}
                                  </td>
                                  <td>
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        w2ncpmCompare.count > w2ncpmSelected.count
                                          ? "text-green-500"
                                          : "text-red-600"
                                      }`}
                                      name={`${
                                        w2ncpmCompare.count > w2ncpmSelected.count
                                          ? "arrow-up"
                                          : "arrow-down"
                                      }`}
                                    />{" "}
                                    {w2ncpmCompare.count}
                                  </td>
                                  <td
                                    className={`${index % 2 === 0 ? "" : "bg-[#F6F6F6]"} relative brd-right`}
                                    onClick={() => {
                                      setFetchW2nCampaign_type('CPM');
                                      setFetchW2n(true);
                                      setBrand(item.brand_id);
                                      setB2BShow(true);
                                      setDate({ startDate: compareStartDate, endDate: compareEndDate });
                                    }}
                                  >
                                    <span
                                      className={`${
                                        (parseInt(w2ncpmCompare.amountinr)||0) > (parseInt(w2ncpmSelected.amountinr) || 0)
                                          ? "greenSpend"
                                          : "redSpend"
                                      }`}
                                      title={w2ncpmCompare.amountinr}
                                    >
                                      {w2ncpmCompare.amount}
                                    </span>
                                    {w2ncpmCompare.amount.includes("cr") && (
                                      <span className="absolute text-[#2DB27A] top-1 right-1">
                                        <sl-icon name="star-fill"></sl-icon>
                                      </span>
                                    )}
                                  </td>
                                </>
                              ) : (
                                <td colSpan={9} className="text-center">
                                  <div className="d-flex justify-center">
                                    <img src={sundayIcon} alt="No data" />
                                  </div>
                                </td>
                              )}


                            {/* Selected Year Metrics */}
                            {hasSelectedData ? (
                              <>
                                <td className="bg-[#F6F6F6]">
                                    <SlIcon
                                      library="lucide"
                                      className={`${
                                        trackerCompare.dates_count >
                                        trackerSelected.dates_count
                                          ? "text-red-600"
                                          : "text-green-500"
                                      }`}
                                      name={`${
                                        trackerCompare.dates_count >
                                        trackerSelected.dates_count
                                          ? "arrow-down"
                                          : "arrow-up"
                                      }`}
                                    ></SlIcon>{" "}  
                                  {trackerSelected.dates_count}
                                </td>
                                <td className="bg-[#F6F6F6]">
                                   <SlIcon
                                      library="lucide"
                                      className={`${
                                        trackerCompare.count >
                                        trackerSelected.count
                                          ? "text-red-600"
                                          : "text-green-500"
                                      }`}
                                      name={`${
                                        trackerCompare.count >
                                        trackerSelected.count
                                          ? "arrow-down"
                                          : "arrow-up"
                                      }`}
                                    ></SlIcon>{" "}  
                                  {trackerSelected.count}
                                </td>
                                <td
                                    className={`${
                                      index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                    } relative brd-right`}
                                    onClick={() => {
                                      setFetchW2nCampaign_type(null)
                                      setFetchW2n(false);
                                      setBrand(item.brand_id);
                                      setB2BShow(true);
                                      setDate({
                                        startDate: startDate,
                                        endDate: endDate,
                                      });
                                    }}
                                  >
                                    <span
                                      className={`${
                                        (parseInt(
                                          trackerCompare.amountinr
                                        ) || 0) < (parseInt(trackerSelected.amountinr) || 0)
                                          ? "greenSpend"
                                          : "redSpend"
                                      }`}
                                      title={trackerSelected.amountinr}
                                    >
                                      {trackerSelected.amount}
                                    </span>
                                    {trackerSelected.amount.includes("cr") ? (
                                      <span className="absolute text-[#2DB27A] top-1 right-1">
                                        <sl-icon name="star-fill"></sl-icon>
                                      </span>
                                    ) : null}
                                  </td>

                                <td className="bg-[#F6F6F6]">
                                <SlIcon
                                  library="lucide"
                                  className={`${
                                    w2ncpdCompare.dates_count >
                                    w2ncpdSelected.dates_count
                                      ? "text-red-600"
                                      : "text-green-500"
                                  }`}
                                  name={`${
                                    w2ncpdCompare.dates_count >
                                    w2ncpdSelected.dates_count
                                      ? "arrow-down"
                                      : "arrow-up"
                                  }`}
                                ></SlIcon>{" "}
                                  {w2ncpdSelected.dates_count}
                                </td>
                                <td className="bg-[#F6F6F6]">
                                <SlIcon
                                  library="lucide"
                                  className={`${
                                    w2ncpdCompare.count >
                                    w2ncpdSelected.count
                                      ? "text-red-600"
                                      : "text-green-500"
                                  }`}
                                  name={`${
                                    w2ncpdCompare.count >
                                    w2ncpdSelected.count
                                      ? "arrow-down"
                                      : "arrow-up"
                                  }`}
                                ></SlIcon>{" "}
                                  {w2ncpdSelected.count}
                                </td>

                                <td
                                    className={`${
                                      index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                    } relative brd-right`}
                                    onClick={() => {
                                      setFetchW2nCampaign_type('CPD')
                                      setFetchW2n(true);
                                      setBrand(item.brand_id);
                                      setB2BShow(true);
                                      setDate({
                                        startDate: startDate,
                                        endDate: endDate,
                                      });
                                    }}
                                  >
                                    <span
                                      className={`${
                                        (parseInt(
                                          w2ncpdCompare.amountinr
                                        ) || 0) < (parseInt(w2ncpdSelected.amountinr) || 0)
                                          ? "greenSpend"
                                          : "redSpend"
                                      }`}
                                      title={w2ncpdSelected.amountinr}
                                    >
                                      {w2ncpdSelected.amount}
                                    </span>
                                    {w2ncpdSelected.amount.includes("cr") ? (
                                      <span className="absolute text-[#2DB27A] top-1 right-1">
                                        <sl-icon name="star-fill"></sl-icon>
                                      </span>
                                    ) : null}
                                </td>

                                <td className="bg-[#F6F6F6]">
                                <SlIcon
                                  library="lucide"
                                  className={`${
                                    w2ncpmCompare.dates_count >
                                    w2ncpmSelected.dates_count
                                      ? "text-red-600"
                                      : "text-green-500"
                                  }`}
                                  name={`${
                                    w2ncpmCompare.dates_count >
                                    w2ncpmSelected.dates_count
                                      ? "arrow-down"
                                      : "arrow-up"
                                  }`}
                                ></SlIcon>{" "}
                                  {w2ncpmSelected.dates_count}
                                </td>
                                <td className="bg-[#F6F6F6]">
                                <SlIcon
                                  library="lucide"
                                  className={`${
                                    w2ncpmCompare.count >
                                    w2ncpmSelected.count
                                      ? "text-red-600"
                                      : "text-green-500"
                                  }`}
                                  name={`${
                                    w2ncpmCompare.count >
                                    w2ncpmSelected.count
                                      ? "arrow-down"
                                      : "arrow-up"
                                  }`}
                                ></SlIcon>{" "}
                                  {w2ncpmSelected.count}
                                </td>
                                <td
                                    className={`${
                                      index % 2 === 0 ? "" : "bg-[#F6F6F6]"
                                    } relative brd-right`}
                                    onClick={() => {
                                      setFetchW2nCampaign_type('CPM')
                                      setFetchW2n(true);
                                      setBrand(item.brand_id);
                                      setB2BShow(true);
                                      setDate({
                                        startDate: startDate,
                                        endDate: endDate,
                                      });
                                    }}
                                  >
                                    <span
                                      className={`${
                                        (parseInt(
                                          w2ncpmCompare.amountinr
                                        ) || 0) < (parseInt(w2ncpmSelected.amountinr) || 0)
                                          ? "greenSpend"
                                          : "redSpend"
                                      }`}
                                      title={w2ncpmSelected.amountinr}
                                    >
                                      {w2ncpmSelected.amount}
                                    </span>
                                    {w2ncpmSelected.amount.includes("cr") ? (
                                      <span className="absolute text-[#2DB27A] top-1 right-1">
                                        <sl-icon name="star-fill"></sl-icon>
                                      </span>
                                    ) : null}
                                </td>
                              </>
                            ) : (
                              <td colSpan={9} className="text-center">
                                <div className="d-flex justify-center">
                                <img src={sundayIcon} alt="No data" />
                                </div>
                              </td>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </tr>
                  ))}
                </table>
              </div>
              {/* 👇 Resizer handle */}
              <div
                className="absolute right-0 top-0 h-full w-2 cursor-col-resize bg-transparent hover:bg-gray-300"
                style={{padding: "0 !important", border: "0", transform: "translateX(50%)"}}
                onMouseDown={(e) => startResize(e, "vTop")}
                onDoubleClick={() => {
                  setColumnWidths(prev => {
                    const updated = { ...prev };
                    delete updated["vTop"]; // remove that column key
                    return updated;
                  });
                }}
              ></div>
            </th>
            <th rowSpan="99" className="vTop2">
              <table className="countsTable">
                <thead>
                  <tr>
                    <th colSpan={selectedReport === "Way2news" ? 2 : 3}>
                      Total Camps {compareYear}
                    </th>
                    <th colSpan={selectedReport === "Way2news" ? 2 : 3} className="bg-[#F6F6F6]">Total Camps {new Date(selectedYear).getFullYear()}</th>
                    <th colSpan={selectedReport === "Way2news" ? 2 : 3}>
                      Total Insertions {compareYear}
                    </th>
                    <th colSpan={selectedReport === "Way2news" ? 2 : 3} className="bg-[#F6F6F6]">Total Insertions {new Date(selectedYear).getFullYear()}</th>
                    <th colSpan={selectedReport === "Way2news" ? 2 : 3}>
                      Total Spent {compareYear}
                    </th>
                    <th colSpan={selectedReport === "Way2news" ? 2 : 3} className="bg-[#F6F6F6]">Total Spent {new Date(selectedYear).getFullYear()}</th>
                  </tr>

                    <tr>
                      {selectedReport !== "Way2news" ? <th rowSpan={2}><div className="d-flex justify-center">
                        {selectedReport}
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader('newspaper', 'dates_count', 'compare')} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "dates_count" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th> : null}
                      <th colSpan={2}>W2N</th>
                      {selectedReport !== "Way2news" ? <th className="bg-[#F6F6F6]" rowSpan={2}><div className="d-flex justify-center">
                        {selectedReport}
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader('newspaper', 'dates_count', 'selected')} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "dates_count" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th> : null}
                      <th colSpan={2} className="bg-[#F6F6F6]">W2N</th>

                      {selectedReport !== "Way2news" ? <th rowSpan={2}><div className="d-flex justify-center">
                        {selectedReport}
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader('newspaper', 'count', 'compare')} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "count" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th> : null}
                      <th colSpan={2}>W2N</th>
                      {selectedReport !== "Way2news" ? <th className="bg-[#F6F6F6]" rowSpan={2}><div className="d-flex justify-center">
                        {selectedReport}
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader('newspaper', 'count', 'selected')} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "count" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th> : null}
                      <th colSpan={2} className="bg-[#F6F6F6]">W2N</th>

                      {selectedReport !== "Way2news" ? <th rowSpan={2}><div className="d-flex justify-center">
                        {selectedReport}
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader('newspaper', 'amount', 'compare')} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "amount" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th> : null}
                      <th colSpan={2}>W2N</th>
                      {selectedReport !== "Way2news" ? <th className="bg-[#F6F6F6]" rowSpan={2}><div className="d-flex justify-center">
                        {selectedReport}
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader('newspaper', 'amount', 'selected')} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "newspaper" && sortOn.sortByColumn === "amount" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th> : null}
                      <th colSpan={2} className="bg-[#F6F6F6]">W2N</th>
                    </tr>

                    <tr>
                      <th>
                        <div className="d-flex justify-center">
                          CPD
                          <div className="top-3 right-2 group-hover:block">
                            <SlTooltip content="sort">
                              <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD", "dates_count", "compare")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "dates_count" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                            </SlTooltip>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="d-flex justify-center">
                          CPM
                          <div className="top-3 right-2 group-hover:block">
                            <SlTooltip content="sort">
                              <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "dates_count", "compare")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "dates_count" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                            </SlTooltip>
                          </div>
                        </div>
                      </th>
                      <th className="bg-[#F6F6F6]"><div className="d-flex justify-center">
                        CPD
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD", "dates_count", "selected")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "dates_count" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th>
                      <th className="bg-[#F6F6F6]"><div className="d-flex justify-center">
                        CPM
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "dates_count", "selected")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "dates_count" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th>
                      <th><div className="d-flex justify-center">
                        CPD
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD", "count", "compare")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "count" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th>
                      <th><div className="d-flex justify-center">
                        CPM
                        <div className="top-3 right-2 group-hover:block">
                          <SlTooltip content="sort">
                            <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "count", "compare")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "count" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                          </SlTooltip>
                        </div>
                      </div></th>
                      <th className="bg-[#F6F6F6]">
                        <div className="d-flex justify-center">
                          CPD
                          <div className="top-3 right-2 group-hover:block">
                            <SlTooltip content="sort">
                              <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD", "count", "selected")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "count" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                            </SlTooltip>
                          </div>
                        </div>
                      </th>
                      <th className="bg-[#F6F6F6]">
                        <div className="d-flex justify-center">
                          CPM
                          <div className="top-3 right-2 group-hover:block">
                            <SlTooltip content="sort">
                              <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "count", "selected")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "count" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                            </SlTooltip>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="d-flex justify-center">
                          CPD
                          <div className="top-3 right-2 group-hover:block">
                            <SlTooltip content="sort">
                              <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD", "amount", "compare")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "amount" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                            </SlTooltip>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="d-flex justify-center">
                          CPM
                          <div className="top-3 right-2 group-hover:block">
                            <SlTooltip content="sort">
                              <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "amount", "compare")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "amount" && sortOn.dataNeedToSorted === 'compare' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                            </SlTooltip>
                          </div>
                        </div>
                      </th>
                      <th className="bg-[#F6F6F6]">
                        <div className="d-flex justify-center">
                          CPD
                          <div className="top-3 right-2 group-hover:block">
                            <SlTooltip content="sort">
                              <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPD", "amount", "selected")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPD" && sortOn.sortByColumn === "amount" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                            </SlTooltip>
                          </div>
                        </div>
                      </th><th className="bg-[#F6F6F6]">
                        <div className="d-flex justify-center">
                          CPM
                          <div className="top-3 right-2 group-hover:block">
                            <SlTooltip content="sort">
                              <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortByHeader("CPM", "amount", "selected")} name={sortOn.sortOrder === 'desc' && sortOn.sortByType === "CPM" && sortOn.sortByColumn === "amount" && sortOn.dataNeedToSorted === 'selected' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                            </SlTooltip>
                          </div>
                        </div>
                      </th>
                    </tr>
                </thead>

                <tbody>
                  {mergedData?.length && mergedData.map((item) => (
                    <tr key={item.brand_id} className="h-8">

                      {selectedReport !== "Way2news" ? (
                        <td>
                          {calculateCount(item.compare?.data || [], "dates_count")}
                        </td>
                      ) : null}
                      <td>
                        {calculateCount(item.compare?.w2ndata || [], "dates_count", "CPD")}
                      </td>
                      <td>
                        {calculateCount(item.compare?.w2ndata || [], "dates_count", "CPM")}
                      </td>

                      {/* Total Camps */}
                      {selectedReport !== "Way2news" ? (
                        <td className="bg-[#F6F6F6]">{calculateCount(item.selected?.data || [], "dates_count")}</td>
                      ) : null}
                      <td className="bg-[#F6F6F6]">{calculateCount(item.selected?.w2ndata || [], "dates_count", "CPD")}</td>
                      <td className="bg-[#F6F6F6]">{calculateCount(item.selected?.w2ndata || [], "dates_count", "CPM")}</td>
      
                      {/* Total Insertions */}
                      {selectedReport !== "Way2news" ? (
                        <td>
                          {calculateCount(item.compare?.data || [], "count")}
                        </td>
                      ) : null}
                      <td>
                        {calculateCount(item.compare?.w2ndata || [], "count", "CPD")}
                      </td>
                      <td>
                        {calculateCount(item.compare?.w2ndata || [], "count", "CPM")}
                      </td>

                      {selectedReport !== "Way2news" ? (
                        <td className="bg-[#F6F6F6]">{calculateCount(item.selected?.data || [], "count")}</td>
                      ) : null}
                      <td className="bg-[#F6F6F6]">{calculateCount(item.selected?.w2ndata || [], "count", "CPD")}</td>
                      <td className="bg-[#F6F6F6]">{calculateCount(item.selected?.w2ndata || [], "count", "CPM")}</td>

                      {/* Total Spend */}
                      {selectedReport !== "Way2news" ? (
                        <td
                          title={calculateCount(item.compare?.data || [], "amount")}
                        >
                          {formatAmount(calculateCount(item.compare?.data || [], "amount"))}
                        </td>
                      ) : null}
                      <td
                        title={calculateCount(item.compare?.w2ndata || [], "amount", "CPD")}
                      >
                        {formatAmount(calculateCount(item.compare?.w2ndata || [], "amount", "CPD"))}
                      </td>
                      <td
                        title={calculateCount(item.compare?.w2ndata || [], "amount", "CPM")}
                      >
                        {formatAmount(calculateCount(item.compare?.w2ndata || [], "amount", "CPM"))}
                      </td>

                      {selectedReport !== "Way2news" ? (
                        <td className="bg-[#F6F6F6]" title={calculateCount(item.selected?.data || [], "amount")}>
                          {formatAmount(calculateCount(item.selected?.data || [], "amount"))}
                        </td>
                      ) : null}
                      <td className="bg-[#F6F6F6]" title={calculateCount(item.selected?.w2ndata || [], "amount", "CPD")}>
                        {formatAmount(calculateCount(item.selected?.w2ndata || [], "amount", "CPD"))}
                      </td>
                      <td className="bg-[#F6F6F6]" title={calculateCount(item.selected?.w2ndata || [], "amount", "CPM")}>
                        {formatAmount(calculateCount(item.selected?.w2ndata || [], "amount", "CPM"))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </th>

          </tr>
          {mergedData?.length && !loader ? (
            <>
              {mergedData.map((item, index) => {
                return (
                  <tr key={item.brand_id} className="h-8">
                    <td className="mobHide stick">{index + 1}</td>
                    <td className="truncate stick" title={item.selected?.brand_name || item.compare?.brand_name}  style={columnWidths.client ? { "max-width": columnWidths.client, overflow: "hidden" } : undefined}>
                      {item.selected?.brand_name || item.compare?.brand_name || '-'}
                    </td>
                  </tr>
                );
              })}
            </>
          ) : !mergedData?.length && !loader ? (
            <NoDataFound colspan="5" />
          ) : (
            <TableLoader colspan="5" />
          )}
        </table>
      </ScrollContainer>}
      </div>
    </div>
  );
}

export default MarketSpendTracker;
